import { render, staticRenderFns } from "./CinemaPage.vue?vue&type=template&id=3d8621e8&"
import script from "./CinemaPage.vue?vue&type=script&lang=ts&"
export * from "./CinemaPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports